import { Directive, Input, OnDestroy } from '@angular/core';

/** Replay the shared saved-field wash. Pass a counter that increases after each successful save. */
@Directive({
  selector: '[appSavedField]',
  standalone: true,
  host: {
    '[class.saved-field]': 'active'
  }
})
export class SavedFieldDirective implements OnDestroy {
  active = false;

  private primed = false;
  private tick = 0;
  private frame = 0;
  private timer: ReturnType<typeof setTimeout> | null = null;

  @Input() set appSavedField(value: number | null | undefined) {
    const next = value ?? 0;
    if (!this.primed) {
      this.primed = true;
      this.tick = next;
      return;
    }
    if (next === this.tick || next === 0) return;
    this.tick = next;
    this.replay();
  }

  ngOnDestroy(): void {
    if (this.timer != null) clearTimeout(this.timer);
    cancelAnimationFrame(this.frame);
  }

  private replay(): void {
    this.active = false;
    if (this.timer != null) clearTimeout(this.timer);
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => {
      this.active = true;
      this.timer = setTimeout(() => {
        this.active = false;
        this.timer = null;
      }, 960);
    });
  }
}
